
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';

const ContactPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ContactHero />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
